module.exports = __webpack_public_path__ + "img/Advantage3.f774677e.png";